<section
  #dropArea
  class="file-drop"
  [class.file-drop--selectable]="selectable()"
  [attr.role]="selectable() ? 'button' : null"
  [attr.tabindex]="selectable() ? 0 : null"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-disabled]="selectable() ? disabled() : null"
  [class.file-drop--highlight]="isDraggingOver && !disabled()"
  (click)="selectFiles($event)"
  (keydown.enter)="selectFiles($event)"
  (keydown.space)="selectFiles($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="isDraggingOver = false"
  (drop)="fileDropped($event)"
>
  <article class="file-drop__content" [class.no-pointer-events]="!allowPointerEvents()">
    @if (illustrationSrc(); as illustration) {
      <img width="80" height="80" alt="" [ngSrc]="illustration" />
    } @else {
      <span class="file-drop__content__img">{{ emoji() }}</span>
    }

    <p
      class="file-drop__title aw-2-mt--m aw-2-txt--h3"
      [class.aw-2-txt--main]="!selectable() && isDraggingOver"
      [class.aw-2-txt--night]="!selectable() && !isDraggingOver"
    >
      <ng-content select="[title]" />
    </p>

    <p
      class="file-drop__subtitle aw-2-mt--s aw-2-txt--body-small aw-2-txt--bold"
      [class.aw-2-txt--main]="!selectable() && isDraggingOver"
      [class.aw-2-txt--steel]="!selectable() && !isDraggingOver"
    >
      <ng-content select="[subtitle]" />
    </p>

    @if (uploadError) {
      <p class="aw-2-mt--m aw-2-txt--body-small aw-2-txt--red">
        {{ uploadError }}
      </p>
    }
  </article>
</section>
